export default __webpack_public_path__ + "static/media/Shoptaki Data AI.477a3c6f.svg";